import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RotatingLines } from "react-loader-spinner";
import Select from "react-select";
import CustomProgressBar from "../../components/global/CustomProgressBar";
import { downloadFile, getAxiosResponse, postAxiosResponse, putAxiosResponse, putOrPostAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import Constants from "../../Constants";
import DateFormat from "../DateFormat";
import { useForm } from "react-hook-form";
import { dateConvertToTimeStamp, transformBlankToNull, isValidHttpUrl } from "../../services/Util";
import { useDispatch } from "react-redux";
import { projectCreationStepFilter } from "../../redux/reducers/ProjectCreationStepSlice";
import { updateProjectRequestIntegrationValue, resetProjectRequestIntegrationValue } from "../../redux/reducers/ProjectRequestIntegrationSlice";
import { updateContentType } from "../../redux/reducers/CreateProjectContentTypeSlice";
import { Breadcrumb } from "../../components/dashboard/Breadcrumb";
import EloquaCredential from "../settings/integrationSettings/EloquaCredential";
import jQuery from "jquery";
import { setSelectedTreeData } from "../../redux/reducers/TreeSlice";
import { updateProjectInfo } from "../../redux/reducers/ProjectInfoSlice";
import { handleError } from "../../services/authApiRoutes/APImethods";
import { logError } from "../../services/authApiRoutes/APImethods";
import { updateAllUserGroupFollowers, updateFollowersCollection } from "../../redux/reducers/ProjectFollowersSlice";
import dateUtil, {DATE_FORMATS} from "../../services/DateUtil";
import { ConditionalBlock } from "../../ConditionalBlock";
import { AttachmentIcon_Height_21 } from "../../AppIcons";
const chunkSize = Constants.CHUNK_SIZE;

export default function ShowProjectRequest() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const param = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const EloquaCredentialMemo = React.memo(EloquaCredential);
  const [showCreateProjectPopup,setShowCreateProjectPopup] = useState(false)
  const [loader, setLoader] = useState(true);
  const [currentChunkIndex, setCurrentChunkIndex] = useState(-1);
  const [fileUploadProgress, setFileUploadProgress] = useState(0);
  const [message, setMessage] = useState("");
  const [showProgress, setShowProgress] = useState(false);
  const [documentFieldId, setDocumentFileId] = useState(-1);
  const [showHideCreateProjectButton, setShowHideCreateProjectButton] = useState(false);
  const projectRequestId = param.id;
  const [options, setOptions] = useState({});
  const [ isFileAttached, setIsFileAttached  ] = useState(false)
  const [requestAssigneeGroup, setRequestAssigneeGroup] = useState([]);
  const [requestAssigneeLanguages, setRequestAssigneeLanguages] = useState([]);
  const [defaultSelectedLang, setDefaultSelectedLang] = useState([]);
  const [targetLangs, setTargetLangs] = useState({});
  const [showActionButtons, setShowActionButtons] = useState(false);
  const [sourceLanguages, setSourceLanguages] = useState([]);
  const [targetLanguages, setTargetLanguages] = useState([]);
  const [showEloquaCredential, setShowEloquaCredential] = useState(false);
  const [serverErrorMessage, setServerErrorMessage] = useState([]);
  const [isValidating, setValidating] = useState(false);
  const [successMessage, setSuccessMessage] = useState();
  const [credentialData, setCredentialData] = useState({});
  const [credentialErrorMessage, setCredentialErrorMessage] = useState(Constants.BLANK);
  const [isLoading, setIsLoading] = useState(true);
  const [projectRequestData, setRequestProjectData] = useState({});
  const [selectedfile, setSelectedFile] = useState("");

  const sourceLanguageRedux = useSelector((reduxStore) => reduxStore.source_language_for_project_creation).value;
  const targetLanguageRedux = useSelector((reduxStore) => reduxStore.target_language_for_project_creation).value;
  const custBootstrapDataRedux = useSelector((store) => store.customer_bootstrap_data).value;
  const permissions = useSelector((reduxStore) => reduxStore.customer_bootstrap_data).value.permissions;
  const projectRequestListData = useSelector((reduxStore) => reduxStore.project_request_list).value;


  const dispatchToProjectRequestIntegrationRedux = (type, value) => {
    dispatch(
      updateProjectRequestIntegrationValue({
        type: type,
        value: value,
      })
    );
  };

  const translate = t;
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });

  function showModel() {
    setShowCreateProjectPopup(true)
    document.body.classList.add("modal-open");
  }
  function hideModel() {
    setShowCreateProjectPopup(false)
    document.body.classList.remove("modal-open");
  }

  const setMessageAndActivateActionButtons = (value) => {
    setMessage(value);
    setShowActionButtons(true);
  };

  const handleFocusOnMessageContent = (event) => {
    setShowActionButtons(true);
    //setSelectedFile("");
  };

  const downloadAttachment = (commentId, fileName) => {
    downloadFile(APIUrls.PROJECT_REQUEST_DISCUSSION_COMMENT_ATTACHMENT_CONTENT(projectRequestId, commentId), fileName);
  };

  const getData = () => {
    let dateTimeStamp = dateConvertToTimeStamp();
    getAxiosResponse(APIUrls.GET_PROJECT_REQUEST(projectRequestId) + "?_=" + dateTimeStamp)
      .then((res) => {
        if (res.data !== "") {
          let result = transformBlankToNull(res?.data?.data);
          setRequestProjectData(result);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };

  const setProjectRequestTreeData = (result) => {
    let assets = result?.assets;
    let data = [];
    if (assets?.length > 0) {
      assets?.forEach((asset) => {
        if (asset.language === null || asset.language !== result?.sourceLanguage) {
          data.push(asset);
        }
      });
      const filteredAssets = Object.values(
        data.reduce((acc, curr, index) => {
          if (!acc[curr.externalId]) {
            acc[curr.externalId] = { ...curr, targetLanguages: [curr.language] };
          } else {
            if (!acc[curr.externalId].targetLanguages.includes(curr.language)) {
              acc[curr.externalId].targetLanguages.push(curr.language);
            }
          }
          return acc;
        }, {})
      );
      filteredAssets?.map((asset) => {
        let targetLangs = [];
        asset.targetLanguages?.forEach((tl) => {
          let lang = targetLanguages.find((t) => t.language === tl);
          targetLangs.push(lang);
        });
        asset.targetLanguages = targetLangs;
      });
      dispatchToProjectRequestIntegrationRedux("selectedAssets", filteredAssets);
      dispatchToProjectRequestIntegrationRedux("displayName", "name");
      dispatchToProjectRequestIntegrationRedux("contentType", assets[0].contentType);
    }
  };

  useEffect(() => {
    setLoader(true);
    getSourceAndTargetLanguages();
    getData();
  }, []);

  useEffect(() => {
    if ((projectRequestData?.displayName !== null || projectRequestData?.displayName !== undefined) && sourceLanguages?.length > 0 && targetLanguages?.length > 0) {
      setLoader(false);
    }
  }, [projectRequestData, sourceLanguages, targetLanguages]);

  useEffect(() => {
    if (sourceLanguages.length > 0 && projectRequestData) {
      let result = projectRequestData.resource?.sourceLanguage;
      dispatchToProjectRequestIntegrationRedux(
        "sourceLanguage",
        sourceLanguages?.find((lang) => lang.language === result)
      );
    }
  }, [sourceLanguages, projectRequestData]);

  useEffect(() => {
    if (targetLanguages.length > 0 && projectRequestData) {
      let result = projectRequestData.resource?.requestTargetLanguages;
      let targetLanags = [];
      result?.forEach((rtl) => {
        let targetLang = targetLanguages?.find((tl) => tl.language === rtl.language);
        targetLanags.push(targetLang);
      });
      dispatchToProjectRequestIntegrationRedux("targetLanguages", targetLanags);

      setProjectRequestTreeData(projectRequestData.resource);
    }
  }, [targetLanguages, projectRequestData]);

  const getSourceAndTargetLanguages = () => {
    getAxiosResponse(APIUrls.GET_ACCOUNT_SOURCE_LANGUAGES)
      .then((res) => {
        if (res.data !== "") {
          setSourceLanguages(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(APIUrls.GET_ACCOUNT_TARGET_LANGUAGES)
      .then((res) => {
        if (res.data !== "") {
          setTargetLanguages(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };

  useEffect(() => {
    var userId = custBootstrapDataRedux?.user?.userId;
    getAxiosResponse(APIUrls.REQUEST_ASSIGNEE_GROUP(userId)).then((res) => {
      setRequestAssigneeGroup(res.data?.data);
      setRequestAssigneeLanguages(res.data?.data?.displayName[0]);
    });
    getAxiosResponse(APIUrls.CUSTOMER_BOOTSTRAP_DATA).then((res) => {
      setOptions(res.data?.data);
    });
  }, [custBootstrapDataRedux]);

  const getAssigneeLanguage = () => {
    if (options.permissions !== undefined) {
      if (!options.permissions?.PROJECT_REQUEST_ASSIGNABLE) {
        return [];
      } else {
        var data = projectRequestData.displayName[0].unassignedLanguages.filter((language) => {
          var target = projectRequestData.displayName[0].requestTargetLanguages.find((targetLang) => {
            return targetLang.language[0].code == language.code;
          });

          if (target.assigneeUser !== null && target.assigneeUser !== "") {
            return target.assigneeUser.userId === custBootstrapDataRedux.user.userId;
          } else {
            var data = requestAssigneeLanguages.find((l) => {
              return l.code === language.code;
            });
            if (data !== undefined) {
              return data;
            }
          }
        });
        return data;
      }
    }
  };

  useEffect(() => {
    if (projectRequestData.displayName !== undefined && options.permissions !== undefined) {
      var selectedLang = [];
      if (projectRequestData.displayName[0]?.unassignedLanguages?.length === 1) {
        selectedLang = projectRequestData.displayName[0]?.unassignedLanguages;
      } else {
        selectedLang = getAssigneeLanguage();
      }
      setDefaultSelectedLang(selectedLang);
      var unSelectedLangs = projectRequestData.displayName[0]?.unassignedLanguages?.filter((lang) => {
        return lang?.code !== selectedLang[0]?.code;
      });
      var langs = [{ label: "Select All", value: "all" }];
      unSelectedLangs.map((target) => {
        langs.push({ label: target.display, value: target });
      });
      setTargetLangs(langs);
    }
  }, [projectRequestData, requestAssigneeLanguages, options]);

  const showCreateProjectButton = () => {
    return (
      projectRequestData.displayName[0].unassignedLanguages.length > 0 &&
      options.permissions?.PROJECT_CUD &&
      (projectRequestData.resource.status == "OPEN" || projectRequestData.resource.status == "ACCEPTED")
    );
  };

  useEffect(() => {
    if (projectRequestData.resource !== undefined && options.permissions?.PROJECT_CUD !== undefined) {
      setShowHideCreateProjectButton(showCreateProjectButton());
    }
  }, [options, projectRequestData]);

  const formatBytes = (bytes, decimals = 2) => {
    if (!+bytes) return "0 Bytes";
    const k = 1024;
    let dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    let i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  };

  const validations = {
    message: {
      required: "Message is required",
      maxLength: {
        value: 3500,
        message: "Message must be 3500 characters long",
      },
    },
  };

  const fileSelection = (e) => {
    if (e.target) {
      setSelectedFile(e.target.files[0]);
      setFileUploadProgress(0)
    }
  };

  const cancelChat = () => {
    setShowActionButtons(false);
    setMessage("");
  };

  const submitCredential = () => {
    setSuccessMessage("Validating credentials...");
    var isPost = true;
    setValidating(true);
    let localCredentialData = JSON.parse(JSON.stringify(credentialData));
    localCredentialData.credentials = {
      USERNAME: jQuery.trim(jQuery("#eloqua-username-input").val()),
      COMPANY_NAME: jQuery.trim(jQuery("#eloqua-company-name-input").val()),
    };
    localCredentialData.credentialsType = "ELOQUA";
    localCredentialData.credentialCharArray = jQuery.trim(jQuery("#eloqua-password-input").val());
    if (localCredentialData?.id) {
      isPost = false;
    }
    putOrPostAxiosResponse(APIUrls.CUSTOMER_EXTERNAL_SERVICE_CREDENTIALS(Constants.ELOQUA), localCredentialData, isPost)
      .then((res) => {
        setValidating(false);
        setSuccessMessage(Constants.BLANK);
        if (res.data?.handledMessage || res.data?.data?.handledMessage) {
          setCredentialErrorMessage(res.data?.handledMessage);
        } else {
          setServerErrorMessage([]);
          setSuccessMessage("Credential successfully updated!");
          hideCredentialModel();
        }
      })
      .catch((err) => {
        setValidating(false);
        setSuccessMessage(Constants.BLANK);
        const errorMessage = "err - ";
        logError(errorMessage, err);   


      });
  };

  const hideCredentialModel = () => {
    setShowEloquaCredential(false);
    setValidating(false);
    document.body.classList.remove("modal-open");
    jQuery(".integration-check-input").prop("checked", false);
  };

  const createProject = () => {
    var copyRequestData = structuredClone(projectRequestData.resource);
    copyRequestData.requestTargetLanguages.map((lang) => {
      lang.projects = [];
    });
    var languageToUse = [];
    defaultSelectedLang.map((selected) => {
      languageToUse.push(selected.language);
    });
    copyRequestData.languagesToUse = languageToUse;
    var payload = transformBlankToNull(copyRequestData);
    putAxiosResponse(APIUrls.CREATE_PROJECT_FROM_REQUEST(projectRequestId), payload).then((res) => {
      if (res.data.handledMessage === "No credentials for ELOQUA") {
        setShowEloquaCredential(true);
      } else if (res.data.id && res.data.id !== "") {
        hideModel();
        setShowEloquaCredential(false);
        dispatch(projectCreationStepFilter(Constants.SOURCE_MATERIAL_STEP_2));
        dispatch(updateContentType(res.data.projectContentType));
        dispatch(setSelectedTreeData([]));
        dispatch(updateProjectInfo(res.data));
        navigate(`/createProject/${res.data.id}`);
      }
    });
  };

  const postMsg = () => {
    const params = new URLSearchParams();
    if (selectedfile === "") {
      params.set("text", message);
      params.set("requestId", projectRequestId);
      params.set("hasDocument", false);
      params.set("documentFileId", "");
    } else {
      params.set("text", message);
      params.set("requestId", projectRequestId);
      params.set("hasDocument", true);
      params.set("documentFileId", "");
    }

    const urlWithParams = `${APIUrls.PROJECT_REQUEST_DISCUSSION_ATTACHMENT_META(projectRequestId)}?${params.toString()}`;
    postAxiosResponse(urlWithParams).then((res) => {
      setDocumentFileId(res.data.documentFileId);
      setCurrentChunkIndex(0);
      setIsFileAttached(false)
    }).catch(err=>{
      console.error(err)
      setIsFileAttached(false)
    })
  };

  useEffect(() => {
    if (currentChunkIndex !== null) {
      setShowProgress(true);
      readAndUploadCurrentChunk();
    }
  }, [currentChunkIndex]);

  const readAndUploadCurrentChunk = () => {
    const file = selectedfile;
    if (file) {
      const reader = new FileReader();
      const from = currentChunkIndex * chunkSize;
      const to = from + chunkSize;
      const blob = file.slice(from, to);
      reader.onload = (e) => uploadChunk(e);
      reader.readAsDataURL(blob);
    } else {
      uploadChunk(null);
    }
  };

  const uploadChunk = (readerEvent) => {
    const file = selectedfile;
    const data = readerEvent ? readerEvent.target.result : {};
    const headers = {
      "Content-Type": "application/octet-stream",
      "CSRF-Token": localStorage.getItem("csrfToken"),
    };
    let params = getMetadataParams();
    var urlPart = "";
    if (file) {
      urlPart = APIUrls.PROJECT_REQUEST_DISCUSSION_ATTACHMENT(projectRequestId) + `?${params.toString()}`;
    } else {
      urlPart = APIUrls.PROJECT_REQUEST_DISCUSSION_ATTACHMENT(projectRequestId).replace("/upload", "") + `?${params.toString()}`;
    }
    const url = `${process.env.REACT_APP_BACKEND_SERVER}${urlPart}`;
    postAxiosResponse(url, data, {headers}).then(
        (response) => {
          if (selectedfile !== "") {
            const filesize = selectedfile.size;
            const chunks = Math.ceil(filesize / chunkSize) - 1;
            const isLastChunk = currentChunkIndex === chunks;
            if (isLastChunk) {
              setCurrentChunkIndex(null);
              setIsFileAttached(false)
              setFileUploadProgress(100);
              setLoader(true);
              getData();
              setMessage("");
              setSelectedFile("");
            } else {
              const chunks = Math.ceil(filesize / chunkSize);
              setFileUploadProgress(Math.round((currentChunkIndex / chunks) * 100));
              setCurrentChunkIndex(currentChunkIndex + 1);
            }
          } else {
            setMessage("");
            setCurrentChunkIndex(null);
          }
          if (response.data.data.body.success === true) {
            setShowActionButtons(false);
            getData();
          }
        }
    )
  };

  const getMetadataParams = () => {
    const params = new URLSearchParams();
    if (selectedfile === "") {
      params.set("text", message);
      params.set("requestId", projectRequestId);
      params.set("hasDocument", false);
      params.set("documentFileId", "");
    } else {
      params.set("name", selectedfile.name);
      params.set("size", selectedfile.size);
      params.set("currentChunkIndex", currentChunkIndex);
      params.set("totalChunks", Math.ceil(selectedfile.size / chunkSize));
      params.set("text", message);
      params.set("requestId", projectRequestId);
      params.set("hasDocument", true);
      params.set("fileDataAttribute", "attachment.fileData");
      params.set("documentFileId", documentFieldId !== -1 ? documentFieldId : "");
    }
    return params;
  };

  const handleLanguageChange = (value) => {
    if (value.value === "all") {
      targetLangs.map((target) => {
        if (target.value !== "all") {
          setDefaultSelectedLang((current) => [...current, target.value]);
        }
      });
      setTargetLangs([]);
    } else {
      setDefaultSelectedLang((current) => [...current, value.value]);
      setTargetLangs(
        targetLangs.filter((lang) => {
          return lang.value.code !== value.value.code;
        })
      );
      if (targetLangs.length > 1) {
      }
    }
  };
  const removeLanguage = (selectedLang) => {
    setTargetLangs((current) => [...current, { label: selectedLang.display, value: selectedLang }]);
    setDefaultSelectedLang((current) => current.filter((lang) => lang.code !== selectedLang.code));
  };

  function downloadAssetFile(referenceDocId, type) {
    let filename = [];
    if (type === "reference") {
      filename = projectRequestData.resource.referenceMaterials.filter((reference) => {
        return reference.id === referenceDocId;
      });
    }
    if (type === "source") {
      filename = projectRequestData.resource.sourceMaterial.filter((source) => {
        return source.id === referenceDocId;
      });
    }
    if (filename?.length > 0) {
      downloadFile(APIUrls.DOWNLOAD_UPLOADED_SOURCE_DOUCMENT(projectRequestId, referenceDocId), filename[0].filename);
    }
  }
  const crumbs = [
    { label: "Project requests", url: "project-request/list" },
    { label: "Project request", url: "" },
  ];

  const reopenProject=()=>{
    postAxiosResponse(APIUrls.PROJECT_REQUEST_UNREJECT(param.id),{}).then(res=>{
      getData()
    }).catch(err=>{
      console.error(err)
    })
  }

  const allStatus=(activeStatus)=>{
    let  status=""
      if(activeStatus==="CLOSED") {
        status="Completed"
      }else if(activeStatus === "REJECTED"){
        status="Canceled"
      }else if(activeStatus==="OPEN"){
        status="Open"
      }else if(activeStatus==="ACCEPTED"){
        status="Accepted"
      }
    return status;
  }  

  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap campaign-section">
            <Breadcrumb crumbs={crumbs} />
            <div className="translate-request-page">
              {loader ? (
                <div className="gb-overlay show">
                  <div className="gb-loader">
                    <RotatingLines strokeColor="#0096FF" strokeWidth="5" width="196" visible={true} />
                  </div>
                </div>
              ) : (
                <div className="white-bg mar-bot50">
                  <div className="translate-heading ">
                    <div>
                      <div className="campaign-name">
                        <button className="back-btn" aria-label="back" onClick={() => navigate("/project-request/list")}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
                            <path
                              d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                              fill="#4D4D4D"></path>
                          </svg>
                        </button>
                        <h3>{projectRequestData?.resource?.name}</h3>
                        {projectRequestData?.resource?.status !=="REJECTED" && projectRequestData?.resource?.status !=="CLOSED"?
                        <button aria-label="Edit" className="name-edit" onClick={() => navigate(`/project-request/edit/${projectRequestId}`)}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                            <path
                              d="M0.25 15.25H17.75V16.5H0.25V15.25ZM14.875 4.625C15.375 4.125 15.375 3.375 14.875 2.875L12.625 0.625C12.125 0.125 11.375 0.125 10.875 0.625L1.5 10V14H5.5L14.875 4.625ZM11.75 1.5L14 3.75L12.125 5.625L9.875 3.375L11.75 1.5ZM2.75 12.75V10.5L9 4.25L11.25 6.5L5 12.75H2.75Z"
                              fill="#1D4ED8"></path>
                          </svg>
                        </button>:Constants.BLANK}
                      </div>
                      {projectRequestData?.resource?.status !=="REJECTED" && projectRequestData?.resource?.status !=="CLOSED"?
                      <p>
                        <b>Submitted : </b>
                        <DateFormat date={projectRequestData?.resource?.createdDate} />
                      </p>:Constants.BLANK}
                      {projectRequestData?.resource?.projectInfo?.unassignedLanguages && projectRequestData?.resource?.projectInfo?.unassignedLanguages.length  > 0? 
                     <p>{translate('project_request_assigned.instructions')}</p>:Constants.BLANK }
                     {projectRequestData?.resource?.status ==='REJECTED'?
                      <p>{translate('project_request_assigned.canceled')}</p>:Constants.BLANK
                     }
                    </div>
                  </div>
                  <div className="dashboard-top flex-center">
                    <div className="flex-left flex-center">
                      <h4>Details</h4>
                    </div>
                    <div className="flex-right">
                      {  projectRequestData?.resource?.status ==='REJECTED' && permissions.PROJECT_REQUEST_ASSIGNABLE ? 
                       
                        <button className="blue-btn active" onClick={reopenProject}>
                        Re-open Request
                      </button>
                      : showHideCreateProjectButton ?
                      <button className="blue-btn active" onClick={showModel}>
                      Create Project
                      </button>:"" }
                    </div>
                  </div>
                  <div className="flex wrap-dropdown wrap-dropdown-gap">
                    <div className="global-dropdown-block flex-center">
                      <label>Department</label>
                      {projectRequestData?.resource?.userGroup?.name}
                    </div>
                    <div className="global-dropdown-block flex-center">
                      <label>Request Name</label>
                      {projectRequestData?.resource?.name}
                    </div>
                    <div className="global-dropdown-block flex-center">
                      <label>Requester</label>
                      {projectRequestData?.resource?.owner?.firstName + " " + projectRequestData?.resource?.owner?.lastName}
                    </div>
                    <div className="global-dropdown-block flex-center">
                      <label>Campaign</label>
                      {projectRequestData?.resource?.workspace?.name ? projectRequestData?.resource?.workspace?.name : "NA"}
                    </div>
                    <div className="global-dropdown-block flex-center">
                      <label>Priority</label>
                      {projectRequestData?.resource?.priority ? projectRequestData?.resource?.priority : "NA"}
                    </div>
                    <div className="global-dropdown-block flex-center">
                      <label>Translation Date</label>
                      <DateFormat date={projectRequestData?.resource?.translationDueDate} />
                    </div>
                    <div className="global-dropdown-block flex-center">
                      <label>Purchase Order Number</label>
                      {projectRequestData?.resource?.purchaseOrder ? projectRequestData?.resource?.purchaseOrder?.poNumber : "NA"}
                    </div>
                    <div className="global-dropdown-block flex-center">
                      <label>Tags</label>
                      <div className="multiselect-output flex">
                        {projectRequestData?.resource?.tags?.length > 0
                          ? projectRequestData?.resource?.tags?.map((tag, index) => {
                              return <button key={index}>{tag}</button>;
                            })
                          : "NA"}
                      </div>
                    </div>
                    <div className="global-dropdown-block flex-center">
                      <label>Status</label>
                     <small> {projectRequestData?.resource?.status === 'REJECTED'?
                         "Canceled by "+projectRequestData?.resource?.rejection?.user?.firstName +" "+projectRequestData?.resource?.rejection?.user?.lastName +
                         " ("+ dateUtil.format(projectRequestData?.resource?.rejection?.createdDate)+ ") " + projectRequestData?.resource?.rejection?.reason :
                         allStatus(projectRequestData?.resource?.status)}</small>
                    </div>
                    <div className="global-dropdown-block flex-center w-d100">
                      <label>Notes and Instructions</label>
                      {projectRequestData?.resource?.notes ? projectRequestData?.resource?.notes : "NA"}
                    </div>
                  </div>

                  <h5 className="heading-width-border mar-bot30">Source Materials</h5>
                  <div className="project-ref-matrial materials-tab-content">
                    {projectRequestData?.resource?.sourceMaterial ? (
                      projectRequestData?.resource?.sourceMaterial?.map((source, index) => {
                        return (
                          <div className="uploading-files-block uploading-success" key={index}>
                            <div className="uploading-file-list flex">
                              <div className="left-file-desc flex-center">
                                <div className="icon-block">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
                                    <path
                                      d="M12.375 17.875H20.625M12.375 23.375H16.5M5.5 5.5V27.5C5.5 28.2293 5.78973 28.9288 6.30546 29.4445C6.82118 29.9603 7.52065 30.25 8.25 30.25H24.75C25.4793 30.25 26.1788 29.9603 26.6945 29.4445C27.2103 28.9288 27.5 28.2293 27.5 27.5V11.4703C27.5 11.1039 27.4267 10.7412 27.2846 10.4036C27.1424 10.0659 26.9342 9.76008 26.6723 9.504L20.5673 3.53375C20.0535 3.0314 19.3635 2.75009 18.645 2.75H8.25C7.52065 2.75 6.82118 3.03973 6.30546 3.55546C5.78973 4.07118 5.5 4.77065 5.5 5.5V5.5Z"
                                      stroke="#2C8D94"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"></path>
                                    <path
                                      d="M19.25 2.75V8.25C19.25 8.97935 19.5397 9.67882 20.0555 10.1945C20.5712 10.7103 21.2707 11 22 11H27.5"
                                      stroke="#2C8D94"
                                      strokeWidth="2"
                                      strokeLinejoin="round"></path>
                                  </svg>
                                </div>
                                <div className="file-text">
                                  <span className="ext-name">{source?.filename}</span>
                                  <strong>
                                    <span className="date-name">
                                      <DateFormat date={source?.createdDate} />
                                    </span>
                                    <span className="file-size">{source.sizeInKilobytes / 1000} MB</span>
                                  </strong>
                                </div>
                              </div>
                              <div className="file-actions flex-center">
                                <button
                                  title={`Download - ${source?.filename}`}
                                  aria-label={`Download - ${source?.filename}`}
                                  className="download-icon"
                                  onClick={() => downloadAssetFile(source.id, "source")}>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
                                    <path
                                      d="M8.00087 17.6527L15.0742 10.5794C15.1834 10.4518 15.2405 10.2878 15.234 10.12C15.2275 9.9522 15.158 9.79304 15.0392 9.67431C14.9205 9.55558 14.7614 9.48602 14.5936 9.47954C14.4258 9.47306 14.2617 9.53013 14.1342 9.63935L8.66753 15.0993V1.33268C8.66753 1.15587 8.5973 0.986302 8.47227 0.861278C8.34725 0.736254 8.17768 0.666016 8.00087 0.666016C7.82406 0.666016 7.65449 0.736254 7.52946 0.861278C7.40444 0.986302 7.3342 1.15587 7.3342 1.33268V15.0993L1.8742 9.63935C1.81444 9.56956 1.74089 9.51288 1.65818 9.47287C1.57547 9.43285 1.48538 9.41036 1.39357 9.40682C1.30176 9.40327 1.2102 9.41874 1.12465 9.45226C1.0391 9.48577 0.961404 9.53661 0.896434 9.60158C0.831464 9.66655 0.780626 9.74425 0.747109 9.8298C0.713593 9.91535 0.698122 10.0069 0.701669 10.0987C0.705215 10.1905 0.727702 10.2806 0.767717 10.3633C0.807733 10.446 0.864413 10.5196 0.934201 10.5794L8.00087 17.6527Z"
                                      fill="#6D7080"></path>
                                  </svg>
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <p id="sourceLink">
                        {isValidHttpUrl(projectRequestData?.resource?.sourceMaterialDescription) ? (
                          <a id={"source-doc-" + projectRequestData?.resource?.id} target="_blank" href={projectRequestData?.resource?.sourceMaterialDescription}>
                            {projectRequestData?.resource?.sourceMaterialDescription}
                          </a>
                        ) : (
                          projectRequestData?.resource?.sourceMaterialDescription
                        )}
                      </p>
                    )}
                  </div>
                  {projectRequestData?.resource?.referenceMaterials?.length > 0 ? (
                    <>
                      <h5 className="heading-width-border mar-bot30">Reference Materials</h5>
                      <div className="project-ref-matrial materials-tab-content">
                        {projectRequestData?.resource?.referenceMaterials?.map((reference, index) => {
                          return (
                            <div className="uploading-files-block uploading-success" key={index}>
                              <div className="uploading-file-list flex">
                                <div className="left-file-desc flex-center">
                                  <div className="icon-block">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
                                      <path
                                        d="M12.375 17.875H20.625M12.375 23.375H16.5M5.5 5.5V27.5C5.5 28.2293 5.78973 28.9288 6.30546 29.4445C6.82118 29.9603 7.52065 30.25 8.25 30.25H24.75C25.4793 30.25 26.1788 29.9603 26.6945 29.4445C27.2103 28.9288 27.5 28.2293 27.5 27.5V11.4703C27.5 11.1039 27.4267 10.7412 27.2846 10.4036C27.1424 10.0659 26.9342 9.76008 26.6723 9.504L20.5673 3.53375C20.0535 3.0314 19.3635 2.75009 18.645 2.75H8.25C7.52065 2.75 6.82118 3.03973 6.30546 3.55546C5.78973 4.07118 5.5 4.77065 5.5 5.5V5.5Z"
                                        stroke="#2C8D94"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"></path>
                                      <path
                                        d="M19.25 2.75V8.25C19.25 8.97935 19.5397 9.67882 20.0555 10.1945C20.5712 10.7103 21.2707 11 22 11H27.5"
                                        stroke="#2C8D94"
                                        strokeWidth="2"
                                        strokeLinejoin="round"></path>
                                    </svg>
                                  </div>
                                  <div className="file-text">
                                    <span className="ext-name">{reference?.filename}</span>
                                    <strong>
                                      <span className="date-name">
                                        <DateFormat date={reference?.createdDate} />
                                      </span>
                                    </strong>
                                  </div>
                                </div>
                                <div className="file-actions flex-center">
                                  <button
                                    title={`Download - ${reference?.filename}`}
                                    aria-label={`Download - ${reference?.filename}`}
                                    className="download-icon"
                                    onClick={() => downloadAssetFile(reference.id, "reference")}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
                                      <path
                                        d="M8.00087 17.6527L15.0742 10.5794C15.1834 10.4518 15.2405 10.2878 15.234 10.12C15.2275 9.9522 15.158 9.79304 15.0392 9.67431C14.9205 9.55558 14.7614 9.48602 14.5936 9.47954C14.4258 9.47306 14.2617 9.53013 14.1342 9.63935L8.66753 15.0993V1.33268C8.66753 1.15587 8.5973 0.986302 8.47227 0.861278C8.34725 0.736254 8.17768 0.666016 8.00087 0.666016C7.82406 0.666016 7.65449 0.736254 7.52946 0.861278C7.40444 0.986302 7.3342 1.15587 7.3342 1.33268V15.0993L1.8742 9.63935C1.81444 9.56956 1.74089 9.51288 1.65818 9.47287C1.57547 9.43285 1.48538 9.41036 1.39357 9.40682C1.30176 9.40327 1.2102 9.41874 1.12465 9.45226C1.0391 9.48577 0.961404 9.53661 0.896434 9.60158C0.831464 9.66655 0.780626 9.74425 0.747109 9.8298C0.713593 9.91535 0.698122 10.0069 0.701669 10.0987C0.705215 10.1905 0.727702 10.2806 0.767717 10.3633C0.807733 10.446 0.864413 10.5196 0.934201 10.5794L8.00087 17.6527Z"
                                        fill="#6D7080"></path>
                                    </svg>
                                  </button>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  ) : null}
                  <div className="translate-source-block">
                    <div className="step-2-section mar-bot30">
                      <div className="flex wrap-dropdown mb-0">
                        <div className="global-dropdown-block">
                          <label>Source language</label>
                          {projectRequestData?.displayName?.length > 0 && projectRequestData?.displayName[0]?.sourceLanguage[0]?.display}
                        </div>
                        {/* <div className="cust-arrow"></div> */}
                      </div>
                    </div>
                    <div className="step-2-section mar-bot30">
                      <div className="flex wrap-dropdown mb-0">
                        <div className="global-dropdown-block">
                          <label>Target languages</label>
                        </div>
                        <div className="table-responsive global-table">
                          <table className="sortable" aria-label="Target languages">
                            <thead>
                              <tr>
                                <th>Language</th>
                                <th>Assignee</th>
                                <th>Projects</th>
                              </tr>
                            </thead>
                            <tbody>
          {projectRequestData?.displayName && projectRequestData?.displayName[0]?.requestTargetLanguages && projectRequestData?.displayName[0]?.requestTargetLanguages?.length > 0 && projectRequestData?.displayName[0]?.requestTargetLanguages?.map((targetLangs, index) => {
            return (
              <tr style={{ textAlign: "center" }} key={index}>
                <td className="align-left">{targetLangs?.language[0].display}</td>
                <td className="align-left">
                  {targetLangs?.assigneeUser && targetLangs?.assigneeUser !== null ?
                     targetLangs?.assigneeUser?.fullName
                    : "Unassigned"}
                </td>
                <td className="align-left">
                {
  projectRequestData?.resource?.projectInfo?.projects &&
  projectRequestData?.resource?.projectInfo?.projects?.length > 0 ? (
    (() => {
      const matchingProjects = projectRequestData?.resource?.projectInfo?.projects?.filter(project =>
        project?.targetLanguages?.includes(targetLangs?.language[0]?.language)
      );

      return matchingProjects.length > 0 ? (
        matchingProjects.map((project, index) => (
          <Link to={`/project/${project?.id}`} key={index}>
            {project?.name}
          </Link>
        ))
      ) : (
        'No Project'
      );
    })()
  ) : (
    'No Project'
  )
}
                </td>
              </tr>
            );
          })}
        </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h5 className="heading-width-border mar-bot30">Discussion</h5>
                  <div className="translate-source-block mar-bot30">
                    <div className="table-responsive global-table">
                      <table className="sortable relative">
                        <tbody>
                          {projectRequestData?.resource?.comments?.length > 0 ? (
                            projectRequestData?.resource?.comments?.map((comment, index) => {
                              return (
                                <tr key={index}>
                                  <td>{comment?.creatorDisplayName}</td>
                                  <td>
                                    <span aria-label={dateUtil.format(comment?.createdDate, DATE_FORMATS.DATE_TIME)}></span>
                                    <span aria-hidden={true}>
                                      <DateFormat date={comment?.createdDate} format={DATE_FORMATS.SHORT_DATE_TIME} />
                                    </span></td>
                                  <td>
                                    <b>{comment?.text}</b>
                                  </td>
                                  {comment?.attachment !== null ? (
                                    <td>
                                    <span className='attachment-icon'>
                                      {AttachmentIcon_Height_21}
                                    </span>
                                      <Link onClick={() => downloadAttachment(comment.id, comment?.attachment?.filename)}>{comment?.attachment?.filename}</Link>
                                    </td>
                                  ) : (
                                   <td tabIndex={-1}></td>
                                  )}
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td>
                                <p className="m-0">No one has discussed this request yet. When someone does, it will show here.</p>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="request-chat-block translate-source-block">
                    <div className="requester-name">{custBootstrapDataRedux?.user?.firstName + " " + custBootstrapDataRedux?.user?.lastName}</div>
                    <div className="campaign_details-task-create-form discussion-form p-0">
                      <div className="projects-heading">
                        <h5>Comments</h5>
                      </div>
                      <form onSubmit={handleSubmit(postMsg)}>
                        <div className="task-form-content">
                          <div className="form-group text p-0 border-b">
                            <div className="form-text">
                              <label>Message </label>
                              <textarea
                                className="textarea"
                                id="msg-content"
                                aria-label="message"
                                placeholder="3500 characters limit"
                                maxLength={3500}
                                {...register("message", validations.message)}
                                onChange={(event) => setMessageAndActivateActionButtons(event.target.value)}
                                value={message}
                                onFocus={(event) => {
                                  handleFocusOnMessageContent(event);
                                }}></textarea>
                              <p className="error textDanger m-0" aria-label="error alert" role="alert">
                                {errors.message?.message}
                              </p>
                            </div>
                          </div>
                            <div className="flex wrap-dropdown file-btn"> 
                              <div className="file-input flex w-d100">
                                {!isFileAttached ?
                                <div className="input-file mar-bot16">
                                  <input type="file" id="files" onChange={fileSelection} disabled={(currentChunkIndex !== null && currentChunkIndex > 0)}/>
                                  <label className="file-button flex-center" htmlFor="files">
                                    {!selectedfile ? "Add attachment" : "Replace"}
                                  </label>
                                </div>:Constants.BLANK}
                                
                                Maximum file size: 50MB. Create a zip file to upload multiple files.
                                <div className={selectedfile ? "uploading-files-block uploading-success w-d100" : "uploading-files-block uploading-success w-d100 hide"}>
                                  <div className="uploading-file-list flex">
                                    <div className="left-file-desc flex-center">
                                      <div className="icon-block">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                          <path
                                            d="M19.3612 24.1735H5.63886C4.72272 24.1723 3.84447 23.8078 3.19673 23.1599C2.54899 22.5121 2.18464 21.6338 2.18359 20.7176V4.28144C2.18481 3.36542 2.54924 2.48727 3.19696 1.83955C3.84469 1.19182 4.72284 0.827397 5.63886 0.826178H14.402C14.8572 0.825314 15.3081 0.914634 15.7286 1.08898C16.1491 1.26333 16.531 1.51925 16.852 1.84197L21.8 6.78539C22.4488 7.43731 22.8141 8.31894 22.8165 9.23868V20.7176C22.8154 21.6338 22.4511 22.5121 21.8034 23.1599C21.1556 23.8078 20.2774 24.1723 19.3612 24.1735ZM5.63886 2.47091C5.15889 2.47161 4.69878 2.66259 4.35939 3.00197C4.02 3.34136 3.82903 3.80147 3.82833 4.28144V20.7176C3.82903 21.1977 4.01998 21.6578 4.35935 21.9973C4.69872 22.3368 5.15883 22.5279 5.63886 22.5288H19.3612C19.8413 22.5279 20.3014 22.3368 20.6407 21.9973C20.9801 21.6578 21.1711 21.1977 21.1717 20.7176V9.2367C21.1706 8.75346 20.9786 8.29024 20.6375 7.94789L15.6895 3.00447C15.5208 2.83483 15.3202 2.70033 15.0992 2.60874C14.8782 2.51716 14.6412 2.47031 14.402 2.47091H5.63886Z"
                                            fill="#EA6404"></path>
                                          <path
                                            d="M21.2624 9.02539H18.1999C17.2868 9.02452 16.4113 8.66138 15.7656 8.01568C15.1199 7.36998 14.7567 6.49447 14.7559 5.58131V1.65039H16.4006V5.58131C16.4011 6.05837 16.5909 6.51573 16.9282 6.85306C17.2655 7.19039 17.7229 7.38013 18.1999 7.38065H21.2624V9.02539Z"
                                            fill="#EA6404"></path>
                                          <path
                                            d="M9.09858 16.2195C9.0335 16.2177 8.96983 16.2001 8.91305 16.1682C8.84727 16.134 8.77753 16.0958 8.70319 16.0537L6.1374 14.5458C6.07628 14.5057 6.02717 14.4498 5.99529 14.384C5.96422 14.3214 5.94779 14.2525 5.94727 14.1827C5.94722 14.1102 5.96364 14.0387 5.99529 13.9735C6.02596 13.9088 6.07551 13.8549 6.1374 13.8189L8.70319 12.3432C8.76483 12.3046 8.82978 12.2716 8.89727 12.2445C8.95114 12.2222 9.0087 12.2101 9.067 12.209C9.12446 12.2118 9.18064 12.2269 9.23173 12.2534C9.28281 12.2798 9.32761 12.317 9.36305 12.3623C9.44775 12.4479 9.49708 12.5623 9.50121 12.6827C9.50051 12.737 9.48529 12.7902 9.45713 12.8366C9.42521 12.891 9.37991 12.9363 9.32555 12.9682L6.58608 14.5557L6.53082 13.7662L9.31766 15.4327C9.37448 15.4644 9.42036 15.5125 9.44924 15.5708C9.475 15.6235 9.48849 15.6813 9.48871 15.7399C9.48922 15.8646 9.44217 15.9849 9.35713 16.0761C9.32648 16.1168 9.28762 16.1505 9.24308 16.1752C9.19855 16.2 9.14932 16.215 9.09858 16.2195Z"
                                            fill="#EA6404"></path>
                                          <path
                                            d="M9.09903 16.3842C9.00676 16.3829 8.91629 16.3585 8.83588 16.3132C8.77009 16.2796 8.69772 16.2401 8.6214 16.1967L6.05232 14.6882C5.96296 14.631 5.89121 14.5502 5.84509 14.4546C5.80286 14.3702 5.78036 14.2773 5.7793 14.1829C5.78005 14.0858 5.80253 13.99 5.84509 13.9026C5.88955 13.8086 5.96161 13.7304 6.05167 13.6783L8.61745 12.2007C8.68592 12.1578 8.75815 12.1212 8.83324 12.0915C8.94371 12.0425 9.06734 12.0318 9.18457 12.061C9.30181 12.0902 9.40598 12.1576 9.48061 12.2526C9.5932 12.368 9.65785 12.5218 9.66153 12.6829C9.6609 12.7661 9.6382 12.8476 9.59574 12.9191C9.55045 12.9955 9.48693 13.0594 9.41088 13.1053L7.55496 14.1836L9.40759 15.2888C9.4929 15.3369 9.5617 15.4096 9.60496 15.4974C9.64142 15.5722 9.66053 15.6543 9.66088 15.7375C9.66142 15.9022 9.60014 16.0612 9.48917 16.1829C9.44246 16.2426 9.38342 16.2914 9.31609 16.3262C9.24876 16.3609 9.17472 16.3807 9.09903 16.3842ZM6.69443 14.6823L8.78719 15.9119C8.85759 15.9526 8.92469 15.9888 8.98917 16.0224C9.03118 16.0446 9.07979 16.0509 9.12608 16.0401C9.17237 16.0294 9.21322 16.0023 9.24114 15.9638C9.29873 15.9027 9.33033 15.8215 9.3293 15.7375C9.32891 15.7033 9.32081 15.6695 9.30561 15.6388C9.28959 15.6106 9.26555 15.5877 9.23653 15.573L7.22995 14.3724L6.69443 14.6823ZM6.37535 13.873L6.22009 13.9619C6.18718 13.9813 6.16083 14.0102 6.14443 14.0448C6.12361 14.0878 6.11282 14.1351 6.11285 14.1829C6.11324 14.2286 6.12404 14.2736 6.14443 14.3145C6.16336 14.3542 6.19297 14.388 6.22996 14.4119L6.4214 14.5237L6.37535 13.873ZM6.71877 14.0665L6.7339 14.2796L6.90627 14.179L6.71877 14.0665ZM6.71153 13.6796L7.23259 13.9901L9.24509 12.8244C9.27393 12.8073 9.29811 12.7833 9.31548 12.7546C9.32897 12.7331 9.33647 12.7083 9.33719 12.6829C9.33269 12.6032 9.29813 12.5282 9.24048 12.473C9.15166 12.3737 9.08785 12.3737 9.06745 12.3737C9.02994 12.3751 8.99297 12.3831 8.95824 12.3974C8.90003 12.4214 8.84391 12.4502 8.79048 12.4836L6.71153 13.6796Z"
                                            fill="#EA6404"></path>
                                          <path
                                            d="M10.9549 17.2788C10.8531 17.2738 10.7558 17.2349 10.6786 17.1682C10.634 17.1357 10.5978 17.0928 10.5732 17.0434C10.5486 16.9939 10.5362 16.9393 10.5372 16.884C10.5379 16.8181 10.5539 16.7533 10.5839 16.6946L13.7891 10.1321C13.8233 10.062 13.8753 10.0021 13.9398 9.95837C13.9974 9.91694 14.0662 9.894 14.1372 9.89258C14.2372 9.89676 14.3329 9.93454 14.4089 9.99982C14.4536 10.033 14.4896 10.0766 14.5137 10.1268C14.5377 10.177 14.5492 10.2323 14.547 10.288C14.5462 10.3539 14.5302 10.4187 14.5003 10.4774L11.3029 17.0399C11.2695 17.1091 11.2193 17.1688 11.1569 17.2136C11.0981 17.256 11.0274 17.2788 10.9549 17.2788Z"
                                            fill="#EA6404"></path>
                                          <path
                                            d="M10.9533 17.4419C10.8154 17.4371 10.6829 17.3864 10.577 17.2978C10.5125 17.2496 10.4603 17.1869 10.4245 17.1148C10.3887 17.0427 10.3704 16.9632 10.3711 16.8826C10.3724 16.791 10.3949 16.7009 10.4369 16.6195L13.6422 10.0609C13.6887 9.96447 13.76 9.88207 13.8487 9.82212C13.9489 9.75601 14.0681 9.725 14.1878 9.73393C14.3074 9.74285 14.4207 9.79123 14.5099 9.87146C14.5743 9.92043 14.6261 9.98393 14.6612 10.0568C14.6963 10.1296 14.7137 10.2097 14.7119 10.2905C14.7106 10.3822 14.6881 10.4723 14.6461 10.5537L11.4468 17.1123C11.4023 17.2069 11.3344 17.2887 11.2494 17.3498C11.1626 17.4103 11.0592 17.4425 10.9533 17.4419ZM14.1356 10.0603C14.0975 10.0609 14.0604 10.0733 14.0297 10.0958C13.9889 10.1234 13.9562 10.1613 13.9349 10.2057L10.7303 16.7649C10.7112 16.8012 10.7008 16.8416 10.7001 16.8826C10.6991 16.9129 10.7058 16.9429 10.7195 16.9699C10.7332 16.9969 10.7534 17.0201 10.7784 17.0373C10.8948 17.1267 10.9862 17.132 11.0606 17.0794C11.1008 17.0507 11.133 17.0122 11.154 16.9675L14.3507 10.4083C14.3697 10.3719 14.3801 10.3316 14.381 10.2905C14.383 10.26 14.3774 10.2295 14.3645 10.2018C14.3516 10.1741 14.3319 10.1501 14.3073 10.132C14.2592 10.0903 14.199 10.0652 14.1356 10.0603Z"
                                            fill="#EA6404"></path>
                                          <path
                                            d="M15.998 16.2202C15.9405 16.2175 15.8842 16.2023 15.8332 16.1756C15.7822 16.1489 15.7376 16.1113 15.7026 16.0656C15.6177 15.9806 15.5683 15.8665 15.5645 15.7465C15.5638 15.6908 15.5789 15.6361 15.6079 15.5886C15.6415 15.5368 15.6865 15.4934 15.7395 15.4616L18.4789 13.8748L18.5342 14.6642L15.748 12.9978C15.6911 12.9662 15.6452 12.918 15.6164 12.8596C15.5907 12.807 15.5772 12.7492 15.577 12.6906C15.5755 12.5659 15.6227 12.4455 15.7086 12.355C15.7398 12.3137 15.7793 12.2793 15.8247 12.2541C15.87 12.229 15.9201 12.2136 15.9717 12.209C16.0368 12.2107 16.1005 12.2283 16.1572 12.2603C16.2226 12.2945 16.2923 12.3327 16.3664 12.3748L18.9322 13.8827C18.9939 13.9184 19.0434 13.9718 19.0743 14.036C19.1055 14.1014 19.1217 14.173 19.1217 14.2455C19.1217 14.318 19.1055 14.3896 19.0743 14.455C19.0436 14.5195 18.9941 14.5732 18.9322 14.609L16.3664 16.0853C16.3007 16.1221 16.2349 16.1511 16.177 16.18C16.121 16.2065 16.0599 16.2202 15.998 16.2202Z"
                                            fill="#EA6404"></path>
                                          <path
                                            d="M15.9985 16.3842C15.9178 16.3818 15.8386 16.3619 15.7663 16.3259C15.6941 16.2899 15.6305 16.2387 15.58 16.1757C15.468 16.0603 15.4039 15.9068 15.4004 15.7461C15.3993 15.6604 15.4221 15.5761 15.4662 15.5026C15.5124 15.43 15.5745 15.3688 15.6478 15.3237L17.5096 14.2447L15.6603 13.1395C15.5746 13.0919 15.5057 13.0191 15.4629 12.9309C15.4265 12.8561 15.4074 12.774 15.407 12.6908C15.4063 12.5245 15.47 12.3645 15.5846 12.2441C15.6572 12.1469 15.7631 12.08 15.8821 12.0563C16.001 12.0326 16.1245 12.0538 16.2287 12.1158C16.2945 12.1493 16.3669 12.1888 16.4432 12.2322L19.009 13.7408C19.099 13.7928 19.1712 13.8708 19.2162 13.9645C19.2588 14.0523 19.2812 14.1485 19.282 14.2461C19.2814 14.3432 19.2589 14.439 19.2162 14.5263C19.1714 14.6209 19.0986 14.6994 19.0077 14.7513L16.4471 16.2283C16.3715 16.2691 16.305 16.3026 16.2439 16.3303C16.167 16.3661 16.0832 16.3845 15.9985 16.3842ZM17.8333 14.4382L15.8208 15.6039C15.792 15.6218 15.7673 15.6455 15.7485 15.6737C15.7352 15.6955 15.7286 15.7206 15.7294 15.7461C15.7335 15.8254 15.7676 15.9001 15.8248 15.9553C15.9142 16.0553 15.9781 16.0553 15.9985 16.0553C16.0351 16.055 16.0713 16.0467 16.1044 16.0309C16.159 16.0059 16.2189 15.9763 16.2833 15.9408L18.355 14.7493L17.8333 14.4382ZM18.6445 13.9072L18.6906 14.5559L18.8458 14.4664C18.8794 14.4475 18.9061 14.4185 18.9221 14.3836C18.9427 14.3404 18.9534 14.2932 18.9534 14.2454C18.9534 14.1976 18.9427 14.1504 18.9221 14.1072C18.906 14.0726 18.8793 14.044 18.8458 14.0257L18.6445 13.9072ZM18.1596 14.2493L18.3471 14.3618L18.332 14.1487L18.1596 14.2493ZM15.9669 12.3737C15.9109 12.3875 15.8615 12.4205 15.8274 12.4671C15.7982 12.4965 15.7752 12.5314 15.7596 12.5698C15.744 12.6082 15.7362 12.6494 15.7366 12.6908C15.737 12.725 15.7451 12.7588 15.7603 12.7895C15.7753 12.8173 15.7982 12.8402 15.8261 12.8553L17.8333 14.0559L18.3682 13.7461L16.2761 12.5164C16.2057 12.4757 16.1379 12.4395 16.0741 12.4059C16.0413 12.387 16.0046 12.376 15.9669 12.3737Z"
                                            fill="#EA6404"></path>
                                        </svg>
                                      </div>
                                      <div className="file-text">
                                        <span className="ext-name">{selectedfile?.name}</span>
                                        <strong>
                                          <span>{formatBytes(selectedfile?.size)}</span>
                                        </strong>
                                      </div>
                                    </div>
                                  </div>
                                  <div className={showProgress ? "right-progressbar" : "right-progressbar hide"}>
                                    <CustomProgressBar
                                      completed={fileUploadProgress}
                                      labelLineHeight="1px"
                                      labelSize="14px"
                                      width="100%"
                                      labelClassName="progressBarLabel"
                                      borderRadius="30px"
                                      labelAlignment="outside"
                                      labelColor="rgba(0,0,0,0.87)"
                                      height="10px"
                                      className="file_upload_progress"
                                      bgColor="#06B878"
                                      baseBgColor="#D1DEF0"
                                      ariaValuetext={fileUploadProgress}
                                      aria-label=""
                                      aria-valuenow={fileUploadProgress}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                        </div>
                          <div className="flex two-col justify-end">
                            <button className="btn btn-bold" disabled={message === "" ? true : false} type="submit" onClick={()=> setIsFileAttached(true) }>
                              Send
                            </button>
                            <button type="button" className="blue-btn" onClick={cancelChat}>
                              Cancel
                            </button>
                          </div>
                      </form>
                    </div>
                  </div>

                  <div className="project-ref-matrial materials-tab-content"></div>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
       {showCreateProjectPopup ?                          
      <div id="modelPopup" className="lightbox-panel">
        <div className="inner-lightbox-panel p-0">
          <div className="modal-header flex popup-header">
            <strong>Choose target languages</strong>
          </div>
          <div className="lightbox-content popup-content">
            <div className="flex wrap-dropdown">
              <div className="global-dropdown-block flex-center">
                <label>{translate("task_campaign.language")}</label>
                <div className="global-dropdown-select">
                  <Select
                    className="global-dropdown-select"
                    classNamePrefix="cw"
                    // value={deliveryStatus.filter(function (option) {
                    //   return option.value === projectDeliveryStatus;
                    // })}
                    aria-label="Target Langs"
                    options={targetLangs}
                    onChange={(e) => handleLanguageChange(e)}
                  />
                </div>
                <div className="multiselect-output flex mar-bot16">
                  {defaultSelectedLang.length > 0
                    ? defaultSelectedLang?.map((lang, index) => {
                        return (
                          <button key={index} onClick={() => removeLanguage(lang)}>
                            <strong>{lang.display}</strong>
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                              <path
                                d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                stroke="#213248"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"></path>
                            </svg>
                          </button>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer modal-footer-border flex px-22">
            <button id="add-follower" className="btn btn-bold active" onClick={() => createProject()} disabled={defaultSelectedLang.length === 0}>
              Create Project
            </button>
            <button
              id="close-add-follower-popup"
              className="btn btn-bold"
              onClick={hideModel}
              //onKeyDown={(e) => handleKeyDownOnCancel(e)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
      : ''}
      {showEloquaCredential && (
        <div className="lightbox-panel sm-lg-lightbox-panel" aria-labelledby="Eloquacredentials" aria-modal="true" role="dialog">
          <div className="inner-lightbox-panel pb-0">
            <div className="modal-header flex padd-lr">
             <h5 id="Eloquacredentials" className="mb-0">Eloqua credentials</h5>
              <button className="close" aria-label="close popup" onClick={() => hideCredentialModel()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                  <path
                    d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z"
                    fill="white"></path>
                  <path
                    d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z"
                    fill="white"></path>
                </svg>
              </button>
            </div>
            <div className="lightbox-content padd-22">
              <div className="flex">
                <div className="leftBlock">
                  <p>Manage your Eloqua login credentials for Eloqua Integration projects.</p>
                  <p>Once you have logged in, you will be able to see all of your Eloqua assets and automate their translation.</p>
                  <p>
                    <a target="_blank" href="https://cloudwords.zendesk.com/entries/46590368">
                      Learn More about Eloqua Integration
                    </a>
                  </p>
                </div>
                <div className="rightBlock">
                  <div className="error">{credentialErrorMessage}</div>
                  <div className="flex wrap-dropdown flex-column mb-0">
                    <EloquaCredentialMemo
                      errorMessages={serverErrorMessage}
                      isValidating={isValidating}
                      successMessage={successMessage}
                      closePopup={hideCredentialModel}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer modal-footer-border flex px-22">
              <button className="btn btn-bold" onClick={() => hideCredentialModel()}>
                Cancel
              </button>
              <button id="save-credential" className="btn btn-bold active" onClick={() => submitCredential(true)}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
